import apiBase from "../../api/axios";

// ============================================================
// PREGUNTAS DE TALENTO USUARIO - Quiz Fortalezas 2.0 (último paso)
// ============================================================

const BASE = "v1/preguntas-talento/preguntas-talento-quiz";

export const getPreguntasTalentoStartService = async () => {
  const response = await apiBase.get(`${BASE}/start/`);
  return response.data;
};

export const getPreguntasTalentoCurrentService = async () => {
  const response = await apiBase.get(`${BASE}/current/`);
  return response.data;
};

export const sendPreguntasTalentoAnswerService = async (payload) => {
  const response = await apiBase.post(`${BASE}/answer/`, payload);
  // La API envuelve en { message, data, status_code }; soportamos ambos
  return response.data?.data ?? response.data;
};

export const getPreguntasTalentoStatusService = async () => {
  const response = await apiBase.get(`${BASE}/status/`);
  return response.data;
};

export const getPreguntasTalentoSummaryService = async () => {
  const response = await apiBase.get(`${BASE}/summary/`);
  return response.data;
};
